var _defs, _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveCustomers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.09 75.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #feefe1;\n      }\n\n      .cls-2 {\n        fill: #fc7f11;\n      }\n\n      .cls-3 {\n        fill: #f8b180;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 36.55,
    cy: 37.63,
    r: 29.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.55,67.13c-16.27,0-29.5-13.23-29.5-29.5s13.23-29.5,29.5-29.5,29.5,13.23,29.5,29.5-13.23,29.5-29.5,29.5ZM36.55,9.63c-15.44,0-28,12.56-28,28s12.56,28,28,28,28-12.56,28-28-12.56-28-28-28Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    className: "cls-2",
    d: "M48.65,30.05c0,2.67-2.17,4.84-4.84,4.84s-4.84-2.17-4.84-4.84c0-2.67,2.17-4.84,4.84-4.84,0,0,0,0,0,0,2.67,0,4.84,2.17,4.84,4.84M46.69,35.96h-5.76c-2.11,0-4.03,1.22-4.93,3.13,2.78.51,5.04,2.51,5.88,5.21h8.63c.9,0,1.64-.73,1.64-1.63h0v-1.25c0-3.01-2.45-5.45-5.46-5.45h0ZM31.13,26.72c-3.27,0-5.91,2.65-5.91,5.92s2.65,5.91,5.92,5.91c3.27,0,5.91-2.65,5.91-5.91,0-3.27-2.65-5.91-5.91-5.91M41.32,48.05v-1.52c0-3.68-2.99-6.67-6.67-6.66,0,0,0,0,0,0h-7.03c-3.68,0-6.67,2.98-6.67,6.67v1.52c0,1.1.9,2,2,2h16.38c1.1,0,1.99-.9,1.99-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCustomers);
export default __webpack_public_path__ + "static/media/Active Customers.c7e3546e48c504d63551ecd226e1417d.svg";
export { ForwardRef as ReactComponent };